<template>
  <h2
    v-if="text && classes"
    :class="classes"
    v-html="text"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Subheading',

  props: {
    text: {
      type: String,
      default: ''
    }
  },

  computed: {
    // Data
    ...mapGetters([ 'myStore' ]),
    // Classes
    classes() {
      const settings = this.myStore(['styles', 'global', 'subheading']) ?? {}
      const fontFamily = settings.font_family ?? 'body'
      // Return
      return [
        // Size
        'md:text-xl',
        // Family
        `font-${fontFamily}`,
        // Weight
        `font-${fontFamily}-${settings.font_weight ?? 'normal'}`,
        // Transform
        settings.text_transform ?? 'normal-case'
      ]
    }
  }
}
</script>

